import { ReactElement } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import SelectMUI, { ISelectMUIProps } from '~/ui/components/inputs/SelectMUI/SelectMUI';

interface IFormSelectMUIProps<TFieldValues extends FieldValues>
  extends Omit<ISelectMUIProps, 'value' | 'onChange' | 'onBlur' | 'inputRef' | 'name' | 'error'> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
}

const FormSelect = <TFieldValues extends FieldValues>({
  control,
  name,
  helperText,
  ...selectProps
}: IFormSelectMUIProps<TFieldValues>): ReactElement => (
  <Controller
    control={control}
    name={name}
    render={({ field: { ref, ...field }, fieldState: { error } }) => (
      <SelectMUI
        {...selectProps}
        {...field}
        inputRef={ref}
        error={Boolean(error)}
        helperText={error?.message ?? helperText}
      />
    )}
  />
);

export default FormSelect;
